import { render } from "./PurchaseOrderReview.vue?vue&type=template&id=89272700&scoped=true&ts=true"
import script from "./PurchaseOrderReview.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrderReview.vue?vue&type=script&lang=ts"

import "./PurchaseOrderReview.vue?vue&type=style&index=0&id=89272700&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89272700"]])

export default __exports__